import axios from "axios";
import React, { useState } from "react";
import { IOrganization } from "../../prep-sa-individual-status-report/models/prep-self-assessment-individual-status-report-models";
import { IEpiProps } from "../models/ilp-page-models";
import { useILPPageContext, useILPPageDispatch } from "../reducers/ilp-page-reducers";

interface IProps {

}

interface IContextProps {
    epiProps: IEpiProps;
    organizations: Array<IOrganization>;
    selectedOrg: string;
    userFullName: string;
    customerKey: string;
}

export const IlpUserInformation = (props: IProps) => {
    const dispatch = useILPPageDispatch();
    const { epiProps, organizations, userFullName, selectedOrg, customerKey }: IContextProps = useILPPageContext();
    const [selectedOrganization, setSelectedOrganization] = useState(selectedOrg);

    function setOrganizationKey(newOrganizationKey) {
        setSelectedOrganization(newOrganizationKey);
        dispatch({
            type: 'updateOrganization',
            data: newOrganizationKey
        })
        getPlans(newOrganizationKey, customerKey);
    }

    function updateLoadingStatus(status) {
        dispatch({
            type: 'updateLoadingStatus',
            data: status
        })
    }

    function updateFormError(status) {
        dispatch({
            type: 'updateFormError',
            data: status
        })
    }

    function getPlans(organizationKey, customerKey) {
        updateLoadingStatus(true);
        const headers = {
            'Content-type': 'application/json; charset=UTF-8'
        }
        axios.get(`/api/v1/ilp/get-plans/${organizationKey}/${customerKey}`, { headers: headers })
            .then(function (response) {
                updateLoadingStatus(false);
                if (response.status === 200 && !response.data.errors) {
                    updateFormError(false);
                    dispatch({
                        type: 'updatePlans',
                        data: response.data
                    })
                }
                else {
                    updateFormError(true);
                }
            })
            .catch(function (error) {
                console.log(error);
                updateLoadingStatus(false);
                updateFormError(true);
            });

    }

    let sortedOrganizations = organizations?.sort((a, b) => {
        return a.name.localeCompare(b.name);
    });

    return (
        <div className="ilp-program">

            <h4 className="h5-styled">{userFullName}</h4>
            {
                sortedOrganizations.length > 1 &&
                <div className="prep-report-program-select">
                    <label htmlFor="organizationSelect" className="h5-styled">{epiProps.currentProgramLabel}</label>
                    <select id="organizationSelect" value={selectedOrganization} onChange={e => setOrganizationKey(e.target.value)}>
                        {sortedOrganizations.map((program: any) => (
                            <option key={program.organizationKey} value={program.organizationKey}>{program.name}</option>
                        ))}
                    </select>
                </div>
            }
            {
                sortedOrganizations.length == 1 &&
                <div className="prep-report-program-advisor">
                    <label htmlFor="organizationSelect" className="h5-styled">{epiProps.currentProgramLabel}</label>
                    <p className="paragraph-large">{sortedOrganizations[0].name}</p>
                </div>
            }
        </div>
    );


}